import { useQuery } from "@tanstack/react-query";
import { customAxios } from "lib/axios";

interface Client {
  _id: string;
  name: string;
  email: string;
  phone: string;
  address: string;
  notes?: string;
  description?: string;
  org: string;
  managedBy: string;
  createdAt: string;
  updatedAt: string;
  __v?: number;
}

interface ClientResponse {
  success: boolean;
  clients: Client[];
}

const getClients = async (signal?: AbortSignal): Promise<Client[]> => {
  const { data } = await customAxios.get<ClientResponse>("/client", {
    signal,
  });

  if (!data.success) {
    throw new Error("Failed to fetch clients");
  }

  return data.clients;
};

export const useGetClients = () =>
  useQuery<Client[], Error>({
    queryKey: ["clients"],
    queryFn: ({ signal }) => getClients(signal),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
